import { render, staticRenderFns } from "./footer-con.vue?vue&type=template&id=dcb75836"
import script from "./footer-con.vue?vue&type=script&lang=js"
export * from "./footer-con.vue?vue&type=script&lang=js"
import style0 from "./footer-con.vue?vue&type=style&index=0&id=dcb75836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports